import MuiBox from '@mui/material/Box';
import type { ComponentProps } from 'react';

export const Box = (props: ComponentProps<typeof MuiBox>) => {
  return <MuiBox {...props} />;
};
